module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShowing) ? _c('div', {
    staticClass: "alert alert-dismissible",
    class: ("alert-" + _vm.alertType),
    attrs: {
      "role": "alert"
    }
  }, [(_vm.dismissible) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeAction
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-container"
  }, [(_vm.showIcon) ? _c('img', {
    class: {
      'alert-with-notice': _vm.notice
    },
    attrs: {
      "src": _vm.getAlertImageUrl(),
      "alt": "payment",
      "width": "50",
      "height": "50"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-container"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))]), _vm._v(" "), _c('p', {
    staticClass: "notice"
  }, [_vm._v(_vm._s(_vm.notice))])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77f1c1cc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/DismissableAlert.vue
// module id = 2176
// module chunks = 1